import React from "react";
import { motion } from "framer-motion";
import { Reveal, goToCheckout } from "./ui";
import { PRICE_CURRENT } from "./data";
export function FinalCTA() {
  return <section className="relative w-full overflow-hidden bg-[var(--accent)] px-4 py-14 text-center sm:px-8 sm:py-20" data-id="element-64" data-mp="3ueqet6qnktd0">
      <div className="pointer-events-none absolute -left-20 top-0 h-56 w-56 rounded-full bg-white/10 blur-3xl" data-id="element-65" data-mp="85fd72nzlx3t" />
      <div className="relative mx-auto max-w-2xl" data-id="element-66" data-mp="m46oyifdn6os">
        <Reveal data-id="element-67" data-mp="m2vlyktra2yq">
          <h2 className="font-serif-display text-[1.8rem] font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-[2.5rem]" data-id="element-68" data-mp="h5vfw9wwp07m">
            No necesitás repetirlo una vez más. Necesitás otra forma de acompañar.
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-white/85 sm:text-base" data-id="element-69" data-mp="qvezjhsg0y3j">
            Accedé hoy a las 6 guías de estrategias + 3 recursos de emergencia de Pequeños
            Pasos, Grandes Logros™.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-70" data-mp="zuik6q79dlk5">
          <p className="mt-7 font-serif-display text-[3.2rem] font-semibold leading-none tracking-[-0.04em] text-white sm:text-[4rem]" data-id="element-71" data-mp="2c56c66kxs9kg">
            {PRICE_CURRENT}
          </p>
          <p className="mt-1 text-xs font-bold uppercase tracking-[0.14em] text-white/80" data-id="element-72" data-mp="2m2ubzaxeg79h">
            Pago único
          </p>

          <motion.button type="button" onClick={goToCheckout} whileHover={{
          scale: 1.015
        }} whileTap={{
          scale: 0.985
        }} transition={{
          type: "spring",
          stiffness: 420,
          damping: 24
        }} className="mt-6 w-full rounded-2xl bg-white px-6 py-4 text-[15px] font-extrabold uppercase leading-snug text-[var(--accent)] shadow-[0_18px_38px_-14px_rgba(0,0,0,0.45)] transition-colors duration-200 ease-out hover:bg-[#eef4ff] focus:outline-none focus-visible:ring-4 focus-visible:ring-white/40 sm:w-auto sm:px-10 sm:py-5 sm:text-lg" data-id="element-73" data-mp="2r2770iyfckn5">
            Empezar a acompañar diferente por {PRICE_CURRENT} →
          </motion.button>

          <p className="mt-4 text-xs font-medium text-white/80" data-id="element-74" data-mp="1jntrruhhzzyc">
            Pago seguro · Acceso inmediato · Garantía de 7 días
          </p>
        </Reveal>
      </div>
    </section>;
}